import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'categories-side_navigation-click';
/**
 * Tracks clicks on the category page side navigation links
 */
export function trackCategoriesSideNavigationClick(categoryPathIdentifier) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { categoryPathIdentifier },
    });
}
